import { useEffect, useState } from 'react';
import { fetchWithAuthentication } from '../actions/BaseAction';

export const useAuthenticatedImage = (
  url: string | null | undefined
): string | undefined => {
  const [src, setSrc] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!url) {
      setSrc(undefined);
      return;
    }

    let cancelled = false;
    let blobUrl: string | null = null;

    fetchWithAuthentication(url).then((blob) => {
      if (cancelled || !blob) {
        return;
      }
      blobUrl = URL.createObjectURL(blob);
      setSrc(blobUrl);
    });

    return () => {
      cancelled = true;
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
      }
    };
  }, [url]);

  return src;
};
